import React from "react";
import { Carousel } from "antd";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";

function SuccessStory() {
  const onChange = (currentSlide) => {
    // console.log(currentSlide);
  };
  return (
    <section
      id="testimonials"
      className="testimonials section-bg"
      style={{ background: "#f4f4f4" }}
    >
      <div className="container">
        <header className="section-header">
          <p>Expert Opinion</p>
        </header>
        <div className="container">
          <Carousel afterChange={onChange} autoplay>
            <div className="row d-flex">
              <div className="swiper-slide col-lg-12 col-md-12">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img
                      src="assets/img/testimonials/image1.png"
                      className="testimonial-img"
                      alt=""
                    />
                    <h3>Angshuman Rajkhowa</h3>
                    <h4>Executive Leadership Role</h4>
                    <div className=" d-flex align-items-center">
                      <span>
                        <img
                          src="assets/img/testimonials/Angshuman1.png"
                          className="testimonialLogo"
                          alt=""
                          width={40}
                          height={40}
                        />
                      </span>
                      <span>
                        <img
                          src="assets/img/testimonials/Angshuman2.png"
                          className="testimonialLogo mx-2"
                          alt=""
                          width={30}
                          height={30}
                        />
                      </span>
                      
                    </div>
                    <p>
                      <FaQuoteLeft className="quote-icon-left" />
                      Here's a groundbreaking solution poised to tackle a myriad
                      of business challenges by harnessing the power of video
                      data analytics. By effortlessly transforming raw footage
                      into actionable insights, this technology addresses
                      critical pain points across various sectors. Pratham
                      offers a multifaceted approach to overcoming business
                      hurdles. Its ability to generate valuable data from video
                      feeds empowers organizations to proactively identify
                      opportunities, mitigate risks, and stay ahead in today's
                      dynamic marketplace.
                      <FaQuoteRight className="quote-icon-right" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex">
              <div className="swiper-slide col-lg-12 col-md-12">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img
                      src="assets/img/testimonials/image2.png"
                      className="testimonial-img"
                      alt=""
                    />
                    <h3>Tony Milando</h3>
                    <h4>
                      Former Chief Supply Chain Officer and Strategic Advisory
                    </h4>
                    <div className=" d-flex align-items-center">
                      <span>
                        <img
                          src="assets/img/testimonials/Tony1.png"
                          className="testimonialLogo"
                          alt=""
                          width={40}
                          height={40}
                        />
                      </span>
                      <span>
                        <img
                          src="assets/img/testimonials/Tony2.png"
                          className="testimonialLogo mx-2"
                          alt=""
                          width={30}
                          height={30}
                        />
                      </span>
                    </div>
                    <p>
                      <FaQuoteLeft className="quote-icon-left" />
                      Pratham stands as a pivotal advancement in the realm of
                      data analysis, offering a seamless platform for users to
                      effortlessly upload videos and conduct comprehensive
                      analysis sans AI coding expertise. This pioneering
                      solution effectively addresses a longstanding void in the
                      market, offering capabilities previously inaccessible. Its
                      intuitive interface and robust functionalities position it
                      as an indispensable resource for businesses aiming to
                      streamline operations and enhance efficiency.
                      <FaQuoteRight className="quote-icon-right" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex">
              <div className="swiper-slide col-lg-12 col-md-12">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img
                      src="assets/img/testimonials/image3.png"
                      className="testimonial-img"
                      alt=""
                    />
                    <h3>Sanjay Singh</h3>
                    <h4>Former Chief Finance Officer </h4>
                    <div className=" d-flex align-items-center">
                      <span>
                        <img
                          src="assets/img/testimonials/sanjay1.png"
                          className="testimonialLogo"
                          alt=""
                          width={40}
                          height={40}
                        />
                      </span>
                      <span>
                        <img
                          src="assets/img/testimonials/sanjay2.png"
                          className="testimonialLogo mx-2"
                          alt=""
                          width={40}
                          height={40}
                        />
                      </span>
                      <span>
                        <img
                          src="assets/img/testimonials/sanjay3.png"
                          alt=""
                          className="testimonialLogo"
                          width={40}
                          height={40}
                        />
                      </span>
                    </div>
                    <p>
                      <FaQuoteLeft className="quote-icon-left" />
                      Pratham heralds a new era in data analytics, empowering
                      users with a transformative platform that simplifies video
                      analysis without the complexities of coding. This tool not
                      only streamlines operations but also democratizes access
                      to advanced analytics, leveling the playing field for
                      businesses of all sizes. Its intuitive design and
                      cutting-edge features mark it as a game-changer in the
                      industry, poised to revolutionize how organizations
                      harness the power of data for strategic decision-making.
                      <FaQuoteRight className="quote-icon-right" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default SuccessStory;
